import { set } from 'date-fns';
import { useState, useEffect } from 'react';

interface TourStep {
  id: number;
  title: string;
  text: string;
  target: string;
  position: 'left' | 'right'; // 'left' or 'right' for simplicity(where is the tour card positioned relative to the target)
}

const tourSteps: TourStep[] = [
  {
    id: 1,
    title: 'Welcome to FIND Resume Builder',
    text: 'Let me guide you through the key features. This is your main chat area where you can interact with our AI to build your resume.',
    target: '[data-tour="chat-area"]',
    position: 'left'
  },
  {
    id: 2,
    title: 'Chat Input',
    text: 'Type your resume information here or use the microphone icon to speak. Our AI will guide you through creating your perfect resume.',
    target: '[data-tour="chat-input"]',
    position: 'left'
  },
  {
    id: 3,
    title: 'Saved Resumes',
    text: 'Access all your saved resumes here. You can edit, share, download, or delete them anytime.',
    target: '[data-tour="saved-resumes"]',
    position: 'right'
  },
  {
    id: 4,
    title: 'Settings',
    text: 'Customize your experience here. Manage your profile, subscription, notifications, and comment preferences.',
    target: '[data-tour="settings"]',
    position: 'left'
  },
  {
    id: 5,
    title: 'Theme Toggle',
    text: 'Switch between light and dark mode for your preferred viewing experience.',
    target: '[data-tour="theme-toggle"]',
    position: 'left'
  }
];

const tourStepsMobile: TourStep[] = [
  {
    id: 1,
    title: 'Welcome to FIND Resume Builder',
    text: 'This is your main chat area where you can interact with our AI to build your resume.',
    target: '[data-tour="chat-area"]',
    position: 'left'
  },
  {
    id: 2,
    title: 'Chat Input',
    text: 'Type your resume information here or use the microphone icon to speak. Our AI will guide you through creating your perfect resume.',
    target: '[data-tour="chat-input"]',
    position: 'left'
  },
  {
    id: 3,
    title: 'Menu',
    text: 'Access saved resumes and settings here by tapping the menu icon.',
    target: '[data-tour="sidebar-trigger"]',
    position: 'right'
  },
  {
    id: 4, title: 'Theme Toggle',
    text: 'Switch between light and dark mode for your preferred viewing experience.',
    target: '[data-tour="theme-toggle"]',
    position: 'left'
  }
];

export const useTour = () => {
  const [isActive, setIsActive] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [hasSeenTour, setHasSeenTour] = useState(false);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const steps = isMobile ? tourStepsMobile : tourSteps;

  useEffect(() => {
    const tourSeen = localStorage.getItem('tour_completed');
    if (tourSeen == "true") {
      setHasSeenTour(true);
    }
  }, []);

  const startTour = () => {
    setIsActive(true);
    setCurrentStep(0);
    setHasSeenTour(true); // Mark that the user has seen the tour at the beginning because otherwise it triggers again on the index page!
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    } else {
      completeTour();
    }
  };

  const cancelTour = () => {
    setIsActive(false);
    setCurrentStep(0);
    localStorage.setItem('tour_completed', 'true');
  };

  const completeTour = () => {
    setIsActive(false);
    setCurrentStep(0);
    localStorage.setItem('tour_completed', 'true');
  };

  return {
    isActive,
    currentStep,
    tourSteps: steps,
    hasSeenTour,
    startTour,
    nextStep,
    cancelTour,
    completeTour
  };
};
